<template>
  <a
    :href="block.data.url"
    class="file-document-access"
    target="_blank"
  >
    <span class="file-document-access-icon">
      <i class="far fa-file-audio text-color-content-audio"></i>
    </span>
    <span class="file-document-access-info">
      <span class="file-document-access-info-name">
        {{ block.data.url }}
      </span>
      <span class="file-document-access-info-action">
        <i class="far fa-play"></i>
      </span>
    </span>
  </a>
</template>

<script>
export default {
  name: 'MoleculeContentNodeBlockAudio',

  props: {
    block: Object
  }
}
</script>
